import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import axios from './axios';
import store from './store';

import '@fortawesome/fontawesome-free/css/all.css';
import 'quill/dist/quill.snow.css';
import './styles/theme.css'



const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.use(store);
app.use(router);

app.mount('#app');
